export default __webpack_public_path__ + "static/media/chatFile.e4c9b3c1.svg";